// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__QiJFS","active":"SwitchDate_active__gRL1n"};